import http from "../../../core/utils/apis/api";

const getLearningPaths = async (options) => {
  try {
    const response = await http({
      method: 'GET',
      url: '/learning-paths',
      params: options,

    });
    return response;
  } catch (e) {
    throw e;
  }
};

const deleteLearningPath = async (id) => {
  try {
    const response = await http({
      method: 'DELETE',
      url: `/learning-paths/${id}`
    });
    return response;
  } catch (e) {
    throw e;
  }
};

const learningPathService = {
  getLearningPaths,
  deleteLearningPath
};

export default learningPathService;
